export default __webpack_public_path__ + "static/media/cedes.d94f366d.jpg";